import { axios } from '../config/axios';
import security from './security'

const Dashboard = {};

// Filtros na URL da chamada, e não em { params }: o cache de ETag do axios usa a URL sem os params como chave,
// e com { params } todos os filtros dividiriam uma entrada (um 304 poderia devolver o corpo de outro filtro)
const query = (filters, names) => names.map((name) => `${name}=${encodeURIComponent(filters?.[name] ?? '')}`).join('&');

Dashboard.findGeneral = () => {
  return security.validation(axios.get('/dashboard/general'));
};

// { start_date, end_date, tecnico_id }
Dashboard.findProntuariosSummary = (filters) => {
  return security.validation(axios.get('/dashboard/prontuarios/summary?' + query(filters, ['start_date', 'end_date', 'tecnico_id'])));
};

Dashboard.findProntuariosDays = (filters) => {
  return security.validation(axios.get('/dashboard/prontuarios/days?' + query(filters, ['start_date', 'end_date', 'tecnico_id'])));
};

// { year, tecnico_id }
Dashboard.findProntuariosMonths = (filters) => {
  return security.validation(axios.get('/dashboard/prontuarios/months?' + query(filters, ['year', 'tecnico_id'])));
};

// { ativo, attendance, start_date, end_date }
Dashboard.findPacientesSummary = (filters) => {
  return security.validation(axios.get('/dashboard/pacientes/summary?' + query(filters, ['ativo', 'attendance', 'start_date', 'end_date'])));
};

// list_type: WITHOUT_PRONTUARIO | WITHOUT_CONTRATO
Dashboard.findPacientesList = (list_type, filters) => {
  return security.validation(axios.get('/dashboard/pacientes/list?' + query({ ...filters, list_type }, ['list_type', 'ativo', 'attendance', 'start_date', 'end_date'])));
};

export default Dashboard;
